module.exports = __webpack_public_path__ + "img/46_32.1873f5e0.png";